import axios from "axios";
import { env } from "../../shared/config/env";
import { attachAuthInterceptor } from "./authInterceptor";

const profileClient = axios.create({
  baseURL: env.api.profile,
  headers: { "Content-Type": "application/json" },
});

attachAuthInterceptor(profileClient);

export default profileClient;
